import { PropTypes } from "prop-types";

const CalculatePriceFormLayout = ({ estimationDetailsSection, orderDetailsSection, mapSection, controlsSection }) => (
  <>
    <div className="d-flex flex-column align-items-start col-12 px-0">
      <div className="col-12 px-0 d-flex flex-column flex-md-row mt-md-2 justify-content-between align-items-start">
        <div className="d-flex flex-column col-md-6 col-12 pl-1 pr-0 pl-md-0">{estimationDetailsSection}</div>

        {orderDetailsSection}
      </div>

      <div className="map col-12 px-0 mt-3 mb-4">{mapSection}</div>
    </div>

    {controlsSection}
  </>
);

CalculatePriceFormLayout.propTypes = {
  estimationDetailsSection: PropTypes.node.isRequired,
  orderDetailsSection: PropTypes.node.isRequired,
  mapSection: PropTypes.node.isRequired,
  controlsSection: PropTypes.node.isRequired,
};

export default CalculatePriceFormLayout;
